// import React from 'react';
// import { Form, FormGroup, FormLabel } from 'react-bootstrap';
// import { leadDetailObjAtom } from '../../Services/_states';
// import { useRecoilState } from 'recoil';
// import TableHeader from '../Shared/TableHeader/index';

// const Notepad = () => {
//   const [leadDetails, setLeadDetail] = useRecoilState(leadDetailObjAtom);
//   const handleChange = (e) => {
//     setLeadDetail({ ...leadDetails, internal_comment: e?.target?.value });
//   };
//   return (
//     <>
//       <FormGroup className="my-2">
//         <Form.Control
//           style={{ height: '' }}
//           as="textarea"
//           rows={12}
//           placeholder="Write here..."
//           value={leadDetails?.internal_comment || ''}
//           onChange={(e) => {
//             handleChange(e);
//           }}
//         />
//       </FormGroup>
//     </>
//   );
// };

// export default Notepad;

import React from 'react';
import { TextField, Box } from '@mui/material';
import { leadDetailObjAtom } from '../../Services/_states';
import { useRecoilState } from 'recoil';

const Notepad = () => {
  const [leadDetails, setLeadDetail] = useRecoilState(leadDetailObjAtom);

  const handleChange = (e) => {
    setLeadDetail({ ...leadDetails, internal_comment: e?.target?.value });
  };

  return (
    <Box my={2}  >
      <TextField
        multiline
        minRows={5}
        fullWidth
        placeholder="Write here..."
        value={leadDetails?.internal_comment || ''}
        onChange={handleChange}
        variant="outlined"
      />
    </Box>
  );
};

export default Notepad;
